// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setPcnRenewalHighlightedIds } from 'redux/modules/projectTracker/actions'

const updatePcnRenewalHighlightedData = highlightedPathIds => (dispatch, getState) => {
  const { data } = getState().projectTracker.pcnRenewal

  // TODO NEXT - Nemo - we could determine all these flags by looping over the data once.
  // If large data sets slow this down, we might be able to get some better performance out of this

  // TODO - stress test this one once we start working with large data sets.
  // we might need to track not only the highlighted path_id but also the pcn_renewal_status
  // if this operation is sluggish with large data sets.
  // NOTE - we make sure of highlightedPathIds.length so we can avoid looping over
  // all the path data when nothing is highlighted and because the data.every() would
  // actually return true if highlightedPathIds.length === 0.
  const allowExternalAction = (
    highlightedPathIds.length
      // loop over all the pcn renewal records that we have
      // check to see if this path will be in the new highlight set
      // if so, make sure this isn't an 'In Progress' type of status we're dealing with here.
      // NOTE - pcn_renewal_status of 5 hard coded here as 'Proposed'
      // NOTE - pcn_renewal_status of 6 hard coded here as 'Expired'
      ? data.every(d => (
        !highlightedPathIds.includes(d.path_id) ||
        d.pcn_renewal_status_code === 5 ||
        d.pcn_renewal_status_code === 6)
      )
      : false
  )

  // today's date but at midnight in UTC.
  const todaysDate = new Date()
  todaysDate.setUTCHours(0, 0, 0, 0)
  const todayStartTimestamp = todaysDate.getTime()

  // certain operations are not allows
  // an internal user can edit the status of paths even if they're "In Progress".
  // However, if a path is expired according to the PCN expiration date,
  // the internal user will not be able to set the status to 'Renew' or 'Filing'
  // TODO - stress test this one once we start working with large data sets.
  const expiredPCNSelected = (
    highlightedPathIds.some(pathId => (
      data.find(d => d.path_id === pathId)?.pcn_expiration_date_ms < todayStartTimestamp
    ))
  )

  // NOTE pcn_renewal_status_code of 5 hard coded here as "Proposed"
  // NOTE - we check for pcn_renewal_status_code here because we want to prevent
  // external users from performing actions on paths which are NOT proposed.
  const proposedPCNSelected = (
    highlightedPathIds.some(pathId => (
      data.find(d => d.path_id === pathId)?.pcn_renewal_status_code === 5
    ))
  )

  // then save that updated list to redux
  dispatch(setPcnRenewalHighlightedIds({
    allowExternalAction,
    expiredPCNSelected,
    highlightedPathIds,
    proposedPCNSelected,
  }))
}

export default updatePcnRenewalHighlightedData
